import * as _ from 'underscore'
let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

function QuickSpecs(props) {
  const {product} = props
  const quickSpecs = _.findWhere(product.specs, {name: 'Quick Specs'});

  // Calculate display value without mutating product
  let displayPrice;

  // Check if already formatted (contains $)
  if (typeof product.startingAt === 'string' && product.startingAt.includes('$')) {
    displayPrice = product.startingAt;
  } else if (product.startingAt === null || product.startingAt === undefined || product.startingAt === '' || product.startingAt === 0){
    displayPrice = "TBD"
  } else {
    try {
      const formattedValue = USDollar.format(product.startingAt);
      // Check if formatting resulted in NaN
      if (formattedValue.includes('NaN')) {
        displayPrice = "TBD"
      } else {
        displayPrice = formattedValue
      }
    } catch (error) {
      displayPrice = "TBD"
    }
  }
  return <div id="quick-specs" style={{
    paddingLeft: 7
  }}>
    <div className='quick-spec-column'>
      <div>
      <div className='quick-spec-column-label'>
        Starting At
      </div>
      {displayPrice}
      </div>
    </div>
    {quickSpecs.tabDataItems.map((content) =>
      <div className='quick-spec-column'>
        <div>
          <div className='quick-spec-column-label'>
            {content.name}
          </div>
          {content.value}
        </div>
      </div>
    )}
    <div className='quick-spec-column'>
      <div>
        <div className='quick-spec-column-label'>
          Interior Color
        </div>
        {product.variants[0].name}
      </div>
    </div>
  </div>
}

export default QuickSpecs;
